// One namespace per feature. RU is the design's copy verbatim; UZ (Latin, PLAN §8 Q1) mirrors every RU key
// (tests/unit/i18n.test.tsx checks it). A feature adds its ru/<ns>.json and uz/<ns>.json here.
import ruAudit from './ru/audit.json';
import ruAuth from './ru/auth.json';
import ruCommon from './ru/common.json';
import ruDashboard from './ru/dashboard.json';
import ruLibrary from './ru/library.json';
import ruOrganizations from './ru/organizations.json';
import ruPlans from './ru/plans.json';
import ruResearch from './ru/research.json';
import ruSettings from './ru/settings.json';
import ruShell from './ru/shell.json';
import ruSites from './ru/sites.json';
import ruStructure from './ru/structure.json';
import ruVariants from './ru/variants.json';
import ruDesigner from './ru/designer.json';
import ruDeploy from './ru/deploy.json';
import uzAudit from './uz/audit.json';
import uzAuth from './uz/auth.json';
import uzCommon from './uz/common.json';
import uzDashboard from './uz/dashboard.json';
import uzLibrary from './uz/library.json';
import uzOrganizations from './uz/organizations.json';
import uzPlans from './uz/plans.json';
import uzResearch from './uz/research.json';
import uzSettings from './uz/settings.json';
import uzShell from './uz/shell.json';
import uzSites from './uz/sites.json';
import uzStructure from './uz/structure.json';
import uzVariants from './uz/variants.json';
import uzDesigner from './uz/designer.json';
import uzDeploy from './uz/deploy.json';
import ruDomains from './ru/domains.json';
import uzDomains from './uz/domains.json';
import ruStore from './ru/store.json';
import uzStore from './uz/store.json';
import ruSearch from './ru/search.json';
import uzSearch from './uz/search.json';
import ruIntegrations from './ru/integrations.json';
import uzIntegrations from './uz/integrations.json';

export type Locale = 'ru' | 'uz';

export const resources = {
  ru: { common: ruCommon, shell: ruShell, auth: ruAuth, plans: ruPlans, settings: ruSettings, audit: ruAudit, sites: ruSites, organizations: ruOrganizations, dashboard: ruDashboard, research: ruResearch, library: ruLibrary, structure: ruStructure, variants: ruVariants, designer: ruDesigner, deploy: ruDeploy, domains: ruDomains, store: ruStore, search: ruSearch, integrations: ruIntegrations },
  uz: { common: uzCommon, shell: uzShell, auth: uzAuth, plans: uzPlans, settings: uzSettings, audit: uzAudit, sites: uzSites, organizations: uzOrganizations, dashboard: uzDashboard, research: uzResearch, library: uzLibrary, structure: uzStructure, variants: uzVariants, designer: uzDesigner, deploy: uzDeploy, domains: uzDomains, store: uzStore, search: uzSearch, integrations: uzIntegrations },
} as const;

export const NAMESPACES = ['common', 'shell', 'auth', 'plans', 'settings', 'audit', 'sites', 'organizations', 'dashboard', 'research', 'library', 'structure', 'variants', 'designer', 'deploy', 'domains', 'store', 'search', 'integrations'] as const;
